import React from 'react';
import { faChevronRight, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import images from '../../../assets/images/images.png';
import { useGetNewsMutation } from '../../../features/authentication/authApiSlice';

const NewsCenter = () => {
  const [expand, setExpand] = React.useState(false);
  const [news, setNews] = React.useState([]);

  const [getNews] = useGetNewsMutation();

  React.useEffect(() => {
    if (expand && !news.length) {
      getNewsAsync();
    }
  }, [expand]);

  async function getNewsAsync() {
    try {
      const newsResponse = await getNews().unwrap();
      setNews(() => newsResponse);
      console.log(newsResponse);
      newsResponse[0];
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  }

  return (
    <div className="additional-tab mb-3 ">
      <h4
        onClick={() => setExpand(!expand)}
        className="d-flex align-items-center justify-content-between">
        News Center{' '}
        <span style={{ transform: `${expand ? 'rotate(90deg)' : 'rotate(0deg)'}` }}>
          <FontAwesomeIcon size="2xl" icon={faChevronRight} />
        </span>
      </h4>
      {expand && (
        <>
          <div className="news-center-content overflow-auto my-3">
            {news[0]?.items.map((item, index) => {
              return (
                <a key={index} target="_blank" rel="noreferrer" className="text-decoration-none" href={item.link}>
                  <div className="news-center-box d-flex align-items-start mb-3">
                    <img
                      src={item.image ? item.image : images}
                      className="flex-shrink-0"
                      alt="Blog image"
                    />
                    <div>
                      <h6>
                        {' '}
                        <FontAwesomeIcon icon={faCalendarAlt} />{' '}
                        {new Date(item.date).toLocaleString('default', {
                          month: 'short',
                          day: 'numeric',
                          year: 'numeric',
                          hour: 'numeric',
                          minute: 'numeric',
                          hour12: true,
                          timeZoneName: 'short',
                          timeZone: 'Asia/Kolkata'
                        })}
                      </h6>
                      <h4 className="mb-2">{item.feedTitle}</h4>
                      <p dangerouslySetInnerHTML={{ __html: item.description }} className="newsTile"></p>
                    </div>
                  </div>
                </a>
              );
            })}
          </div>
          <a className="btn btn-castleWhite w-100" href="https://www.castlelearning.com/resources/castle-blog/" target="_blank" rel="noreferrer">All Castle Blog Posts</a>
        </>
      )}
    </div>
  );
};

export default NewsCenter;
